const ContractType = [{
  id: '1',
  contract: 'contract'
},
{
  id: '2',
  contract: 'permanent'
},
{
  id: '3',
  contract: 'internship'
},
{
  id: '4',
  contract: 'owner'
}]

export default ContractType
